// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.search-container {
    display: flex;
    align-items: center;
    margin-bottom: 5px;
}

.search-container {
    --search-height: 30px;
    font-size: 14px;
}

.search-container > input {
    font-size: inherit;
    height: var(--search-height);
    border-color: rgba(0,0,0,.3);
    border-radius: 5px;
    border-width: 1px;
    line-height: 1.5;
    border-top-right-radius: 0;
    border-bottom-right-radius: 0;
}

.search-container > button {
    font-weight: bold;
    font-size: inherit;
    height: calc(var(--search-height) + 4px);
    border-top-left-radius: 0;
    border-bottom-left-radius: 0;
    margin-left: -1px;
}`, "",{"version":3,"sources":["webpack://./src/css/search.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,mBAAmB;IACnB,kBAAkB;AACtB;;AAEA;IACI,qBAAqB;IACrB,eAAe;AACnB;;AAEA;IACI,kBAAkB;IAClB,4BAA4B;IAC5B,4BAA4B;IAC5B,kBAAkB;IAClB,iBAAiB;IACjB,gBAAgB;IAChB,0BAA0B;IAC1B,6BAA6B;AACjC;;AAEA;IACI,iBAAiB;IACjB,kBAAkB;IAClB,wCAAwC;IACxC,yBAAyB;IACzB,4BAA4B;IAC5B,iBAAiB;AACrB","sourcesContent":[".search-container {\n    display: flex;\n    align-items: center;\n    margin-bottom: 5px;\n}\n\n.search-container {\n    --search-height: 30px;\n    font-size: 14px;\n}\n\n.search-container > input {\n    font-size: inherit;\n    height: var(--search-height);\n    border-color: rgba(0,0,0,.3);\n    border-radius: 5px;\n    border-width: 1px;\n    line-height: 1.5;\n    border-top-right-radius: 0;\n    border-bottom-right-radius: 0;\n}\n\n.search-container > button {\n    font-weight: bold;\n    font-size: inherit;\n    height: calc(var(--search-height) + 4px);\n    border-top-left-radius: 0;\n    border-bottom-left-radius: 0;\n    margin-left: -1px;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
